import {NotificationPayLoad} from 'models';
import {useSnackbar} from 'notistack';
import {useCallback} from 'react';

export const useAlert = () => {
    const {enqueueSnackbar} = useSnackbar();
    const invokeNotifications = useCallback(
        (notification: NotificationPayLoad) => {
            enqueueSnackbar({
                message: notification.message,
                anchorOrigin: {horizontal: 'right', vertical: 'top'},
                variant: 'info',
                autoHideDuration: 5000,
                action: notification.actionUrl,

                //     <AppButton
                //         onClick={() => {
                //             if (notification.actionUrl) {
                //                 window.location.assign(notification.actionUrl);
                //             }
                //         }}
                //         variant="text"
                //         color="primary"
                //         size="small"
                //     >
                //         {notification.actionLabel || 'View'}
                //     </AppButton>
                // ) : undefined,
            });
        },
        [enqueueSnackbar],
    );
    const invokeAlert = useCallback(
        (message: string) => {
            enqueueSnackbar({
                anchorOrigin: {horizontal: 'right', vertical: 'bottom'},
                variant: 'error',
                autoHideDuration: 5000,
                message: message,
            });
        },
        [enqueueSnackbar],
    );
    const invokeSuccessMessage = useCallback(
        (message: string) => {
            enqueueSnackbar({
                message: message,
                anchorOrigin: {horizontal: 'right', vertical: 'bottom'},
                variant: 'success',
                autoHideDuration: 5000,
            });
        },
        [enqueueSnackbar],
    );

    return {invokeAlert, invokeSuccessMessage, invokeNotifications};
};
